<template>
  <div class="stepform__body">
    <ul class="stepform__steps">
      <li class="active"><span>Шаг 1. Доставка</span></li>
      <li :class="current_step >= 2 ? 'active' : ''"><span>Шаг 2. Личный кабинет</span></li>
      <li :class="current_step >= 3 ? 'active' : ''"><span>Шаг 3. Время занятий</span></li>
    </ul>

    <ul class="stepform__content">
      <!--ДОСТАВКА-->
      <li class="stepform__item" v-show="current_step === 1">
        <h4>Доставка</h4>
        <div class="stepform__intro">Мы приготовили для вас посылку с красочными методическими материалами. По какому адресу её отправить? Материалы отправляем "Почтой России".</div>
        <label>
          <span>Индекс</span>
          <input type="text" class="uk-input" placeholder="Индекс" name="index" v-model="delivery.index">
        </label>
        <label>
          <span>Ваш город</span>
          <input type="text" class="uk-input" placeholder="Город" name="city" v-model="delivery.city">
        </label>
        <label>
          <span>Почтовый адрес</span>
          <textarea class="uk-textarea" placeholder="Почтовый адрес" name="address" v-model="delivery.address"></textarea>
        </label>
        <!--<label>
          <span>ФИО получателя</span>
          <input type="text" class="uk-input" placeholder="Контактное лицо" name="name" v-model="delivery.name">
        </label>
        <label>
          <span>Телефон получателя</span>
          <input type="text" class="uk-input" placeholder="Телефон" name="phone" v-model="delivery.phone">
        </label>-->
        <div class="stepform__button">
          <button class="uk-button uk-button-primary" @click="checkNext('delivery')">Дальше</button>
        </div>
      </li>
      <!-- Личный кабинет -->
      <li class="stepform__item" v-show="current_step === 2">
        <h4>Личный кабинет</h4>
        <div class="stepform__intro">Окунитесь в мир интерактивных тренажеров, разгоняющих силу мыслей до сверхскоростей!</div>
        <label>
          <span>Имя и фамилия ребенка - как он будет отображаться на платформе</span>
          <input type="text" class="uk-input uk-margin-bottom" placeholder="Имя" v-model="personal.kid_name" name="kid_name">
          <input type="text" class="uk-input" placeholder="Фамилия" v-model="personal.kid_last_name" name="kid_last_name">
        </label>
        <label>
          <span>Дата рождения ребенка</span>
          <input type="text" autocomplete="off" readonly class="uk-input dates" placeholder="Дата рождения" v-model="personal.birth_date" name="birth_date">
        </label>
        <!--<label>
          <span>Email родителя. Будет использоваться для уведомлений<br>и полезных отчетов о результативности занятий</span>
          <input type="text" class="uk-input" placeholder="Email родителя" v-model="personal.parent_mail" name="parent_mail">
        </label>-->
        <!--<label>
          <span>Email ребенка. Будет использоваться для входа на платформу как логин.<br>На этот емейл мы пришлем данные для входа и пароль. Может использоваться либо емейл родителя, либо можете указать отдельный емейл.</span>
          <input type="text" class="uk-input" placeholder="Email ребенка" v-model="personal.kids_mail" name="kids_mail">
        </label>-->
        <div class="stepform__button">
          <button class="back" @click="current_step--">Назад</button>
          <button class="uk-button uk-button-primary" @click="checkNext('personal')">Дальше</button>
        </div>
      </li>
      <!-- Время занятий -->
      <li class="stepform__item" v-show="current_step === 3">
        <h4>Время занятий</h4>
        <div class="stepform__intro">Для того, чтобы вы максимально быстро приступили к обучению, давайте подберем вам группу. Для этого укажите в какие дни и в какое время вам удобно заниматься. И помните, чем больше вариантов вы предложите, тем быстрее мы подберем группу для вас!</div>
        <div class="stepform__pretitle">Выберите удобные для занятий дни и отмечайте<br>
                                        в какое время по МСК в эти дни удобно заниматься<br>(например "с 13 до 16", "весь день", "c 9 до 18", "с 16 до конца дня" и т.д.)
        </div>
        <div class="stepform__wrap">
          <div class="stepform__day" v-for="day in days" :key="day.id">
            <label>
              <input type="checkbox" class="uk-checkbox" :value="day.title" v-model="day.is_checked">
              <span>{{ day.title }}</span>
            </label>
            <!--<Select2 v-model="day.times" :options="myOptions" :settings="s2_settings" />-->
            <input type="text" class="uk-input" v-model="day.times" placeholder="Удобное время">
          </div>
        </div>
        <div class="stepform__button">
          <button class="back" @click="current_step--">Назад</button>
          <button class="uk-button uk-button-primary" @click="sendForm">Закончить оформление</button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Select2 from 'v-select2-component';
import swal from "sweetalert";
import axios from 'axios'
import 'air-datepicker/dist/js/datepicker.min.js'
import 'air-datepicker/dist/css/datepicker.min.css'

export default {
  components: { Select2 },
  name: "stepform",
  data() {
    return {
      current_step: 1,
      delivery: {
        'index': '',
        'city': '',
        'address': '',
        /*'name': '',
        'phone': ''*/
      },
      personal: {
        'kid_name': '',
        'kid_last_name': '',
        'birth_date': '',
        /*'kids_mail': '',
        'parent_mail': ''*/
      },

      s2_settings: {
        multiple: true,
        minimumResultsForSearch: -1,
        placeholder: "Выберите удобное время"
      },
      myOptions: ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00'],
      days: [
        {
          'title': 'Понедельник',
          'times': null,
          'is_checked': false
        },
        {
          'title': 'Вторник',
          'times': null,
          'is_checked': false
        },
        {
          'title': 'Среда',
          'times': null,
          'is_checked': false
        },
        {
          'title': 'Четверг',
          'times': null,
          'is_checked': false
        },
        {
          'title': 'Пятница',
          'times': null,
          'is_checked': false
        },
        {
          'title': 'Суббота',
          'times': null,
          'is_checked': false
        },
        {
          'title': 'Воскресенье',
          'times': null,
          'is_checked': false
        }
      ]
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  props: {},
  methods: {
    initDatepicker() {
      let app = this;
      let datepicker = $('.dates').datepicker({
        //range: true,
        multipleDates: false,
        //multipleDatesSeparator: ", ",
        dateFormat: "dd-mm-yyyy",
        //minDate: new Date(),
        onSelect(formattedDate, date, inst) {
          //console.log(formattedDate, date, inst);
          //let dates = formattedDate.split(', ');
          //console.log(dates);
          app.personal.birth_date = formattedDate;
        }
      })
    },
    checkNext(val) {
      let arr = this[val];
      let errors = 0;
      for (let item in arr) {
        if (!arr[item]) {
          errors++;
          $('input[name=' + item + ']').addClass('error');
          $('textarea[name=' + item + ']').addClass('error');
          setTimeout(() => {
            $('input[name=' + item + ']').removeClass('error');
            $('textarea[name=' + item + ']').removeClass('error');
          }, 2000)
        }
      }
      if (errors === 0) {
        this.current_step++;
      }
    },
    checkDays() {
      let days = this.days;
      let filtered = days.filter((item) => {
        return item.is_checked && item.times;
      });
      if (filtered.length === 0) {
        swal("Выберите дни и время", "", "error");
        return false;
      }
      return true;
    },
    async sendForm() {
      if (this.checkDays()) {
        let data = {
          'delivery': this.delivery,
          'personal': this.personal,
          'user_id': this.user.id,
          'days': this.days.filter((item) => {
            return item.is_checked && item.times;
          })
        };
        this.$root.wait = true;

        // axios.post(window.location.href, data, {
        //   headers: {
        //     'X-OCTOBER-REQUEST-HANDLER': 'onSaveStepform',
        //     'X-Requested-With': 'XMLHttpRequest'
        //   }
        // })
        let result = await this.http.post('onSaveStepform', data).then((res) => {
          console.log(res);
          this.$root.wait = false;
          window.location.reload();
        });
        //console.log(data);
      }
    }
  },
  inject: ['http'],
  mounted() {
    //$('#my-element').datepicker({ });
    this.initDatepicker();
  }
}
</script>